import apiService from './api.service';

class ServicesService {
  async getServices() {
    try {
      const response = await apiService.post('/info/by-category', {CategoryId:4}, {}, true);
      
      if (response && response.code === 1 && response.data) {
        return {
          success: true,
          data: response.data,
          message: response.message,
        };
      }
      
      return {
        success: false,
        data: [],
        message: response?.message || 'Failed to fetch services',
      };
    } catch (error) {
      return {
        success: false,
        data: [],
        message: error.message || 'An error occurred while fetching services',
      };
    }
  }

  transformServiceData(apiServices) {
    return apiServices
      .filter(service => service.IsPublished && !service.IsDeleted)
      .sort((a, b) => (a.SortOrder || 0) - (b.SortOrder || 0))
      .map(service => ({
        id: service.InfoId,
        name: service.Title,
        title: service.Title,
        subtitle: service.SubTitle,
        description: service.Description || '',
        icon: service.Image,
        imageUrl: service.Image,
        link: service.Link || '#',
        category: service.CategoryId || '',
        cssClass: this.getCssClass(service.Title),
        sortOrder: service.SortOrder,
      }));
  }

  getCssClass(serviceName) {
    const name = serviceName.toLowerCase();
    if (name.includes('visa')) return 'visa-card';
    if (name.includes('permit') && name.includes('residence')) return 'permit-card';
    if (name.includes('passport')) return 'passport-card';
    if (name.includes('etd')) return 'etd-card';
    if (name.includes('pass')) return 'pass-card';
    if (name.includes('citizenship')) return 'citizenship-card';
    if (name.includes('exemption')) return 'exemption-card';
    if (name.includes('work')) return 'work-permit-card';
    return 'service-card';
  }

  getButtonClass(serviceName) {
    const name = serviceName.toLowerCase();
    if (name.includes('visa')) return 'visa-button';
    if (name.includes('permit') && name.includes('residence')) return 'permit-button';
    if (name.includes('passport')) return 'passport-button';
    if (name.includes('etd')) return 'etd-button';
    if (name.includes('pass')) return 'pass-button';
    if (name.includes('citizenship')) return 'citizenship-button';
    if (name.includes('exemption')) return 'exemption-button';
    if (name.includes('work')) return 'work-permit-button';
    return 'apply-button';
  }
}

export default new ServicesService();
